module.exports = __webpack_public_path__ + "static/plugnplay-d014930ae9a7da0a9de5ec8aefa04a73.png";